import STATUS_TRACKER from '@jade/JadeStatusTracker/status-tracker-options.enum'
import { EXTERNAL_ENDPOINTS } from '@/external-endpoints'
export const ITEMS_STATUS_TRACKER = [
  {
    label: 'stepStatusTracker.items.accreditation.label',
    link: {
      external: false,
      label: 'stepStatusTracker.items.accreditation.link',
      href: 'settings/fees'
    },
    status: STATUS_TRACKER.COMPLETED
  },
  {
    label: 'stepStatusTracker.items.dispute.label',
    link: {
      external: true,
      label: 'stepStatusTracker.items.dispute.link',
      href: EXTERNAL_ENDPOINTS.HELP.url(),
      target: '_blank'
    },
    status: STATUS_TRACKER.COMPLETED
  },
  {
    label: 'stepStatusTracker.items.store.label',
    link: {
      external: true,
      label: 'stepStatusTracker.items.store.link',
      href: EXTERNAL_ENDPOINTS.DOCUMENTATION.url(
        'em-construção-documentação-geral-para-integrações'
      ),
      target: '_blank'
    },
    status: STATUS_TRACKER.CURRENT
  },
  {
    label: 'stepStatusTracker.items.activation.label',
    description: 'stepStatusTracker.items.activation.description',
    status: STATUS_TRACKER.NEXT
  }
]
